<template>
  <div id="puzzle-list">
    <div class="img-list-item" v-for="(image, index) in imageList" :key="image.src">
      <div class="preview-container" :style="{background:(index == activeImageIndex && showSettings)?'rgba(255,255,255, 0.3)':'transparent'}">
        <div class="preview" @click="changePuzzle(index)" :style="{backgroundImage: 'url(' + image.src + ')', filter:(index == activeImageIndex)?'none':''}">
          <i class="material-icons" v-if="index == activeImageIndex" @click.stop="showSettings = !showSettings">settings</i>
        </div>
      </div>
      <div class="settings" v-if="index == activeImageIndex && showSettings">
        <div>
          <div>kolommen ({{imageList[index].columns}}):</div>
          <div><input type="range" min="2" max="10" v-model.number="imageList[index].columns" class="slider" id="column-change" @change="updateLocalStorage()"></div>
          <div>rijen ({{imageList[index].rows}}):</div>
          <div><input type="range" min="2" max="10" v-model.number="imageList[index].rows" class="slider" id="row-change" @change="updateLocalStorage()"></div>
        </div>
        <div class="remove">
          <i class="material-icons" id="remove" @click="removeImage()">delete</i>
        </div>
      </div>
    </div>
    <div id="add-src" @click="showModale = true">Voeg toe +</div>
    <modale v-if="showModale" @dismiss="dismiss()">
      <p>Gelieve een link van een foto toe te voegen</p>
      <div>
        <input v-model="newImgSrc" type="text" id="url" autofocus>
        <div id="temp-image-container" v-if="tempImg != null">
          <div id="temp-image" :style="{backgroundImage:'url('+tempImg.src+')', height:tempImg.height + 'px', width:tempImg.width + 'px'}" />
          <div class="button" @click="addImage()">
            <i class="material-icons">save</i> Foto aan lijst toevoegen</div>
        </div>
      </div>
    </modale>
  </div>
</template>

<script>
import Modale from './Modale.vue';
import srcClick from './assets/star.mp3';

var audioClick = new Audio(srcClick);

export default {
  components: {
    Modale
  },
  watch: {
    newImgSrc() {
      this.imageChanged();
    }
  },
  props: ['visitor'],
  data() {
    return {
      showSettings: false,
      activeImageIndex: 0,
      tempImg: null,
      showModale: false,
      newImgSrc: null,
      imageList: [
        {
          src: 'https://imgur.com/eUtSZQN.jpg',
          width: 2247,
          height: 1264,
          rows: 3,
          columns: 5
        },
        {
          src: 'https://imgur.com/35oWKgh.jpg',
          width: 1280,
          height: 720,
          rows: 3,
          columns: 5
        },
        {
          src: 'https://imgur.com/pFeLGkT.jpg',
          width: 1320,
          height: 605,
          rows: 3,
          columns: 5
        },
        {
          src: 'https://imgur.com/jw5EAaQ.jpg',
          width: 1062,
          height: 666,
          rows: 3,
          columns: 5
        }
      ]
    };
  },
  mounted() {
    var localStorageImageList = JSON.parse(localStorage.getItem('puzzles'));
    if (localStorageImageList != null) {
      this.imageList = localStorageImageList;
    }

    this.changePuzzle(0);
  },
  methods: {
    imageChanged() {
      var newImage = new Image();
      newImage.onload = event => {
        var image = event.path[0];
        this.tempImg = {
          src: newImage.src,
          width: 400,
          height: image.height / image.width * 400
        };
      };
      newImage.src = this.newImgSrc;
    },
    removeImage() {
      ga(
        'send',
        'event',
        'ImageList',
        'Removal: ' + JSON.stringify(this.imageList[this.activeImageIndex])
      );

      this.imageList.splice(this.activeImageIndex, 1);
      this.updateLocalStorage();
    },
    addImage() {
      this.showModale = false;
      var newImage = new Image();
      newImage.onload = event => {
        var image = event.path[0];
        this.imageList.push({
          src: this.newImgSrc,
          width: image.width,
          height: image.height,
          rows: 4,
          columns: 4
        });
        console.log(JSON.stringify(image));
        ga('send', 'event', 'ImageList', 'Addition: ' + JSON.stringify(this.imageList[this.imageList.length - 1]));
        this.updateLocalStorage();
      };
      newImage.src = this.newImgSrc;
    },
    changePuzzle(index) {
      this.showSettings = false;
      if (!audioClick.paused) {
        audioClick.pause();
        audioClick.currentTime = 0;
      }
      audioClick.play();
      this.activeImageIndex = index;
      this.$emit('activeImage', this.imageList[index]);
    },
    updateLocalStorage() {
      localStorage.setItem('puzzles', JSON.stringify(this.imageList));
    },
    dismiss() {
      this.showModale = false;
      this.newImgSrc = null;
      this.tempImg = null;
    }
  }
};
</script>

<style scoped>
.settings {
  font-size: 0.9em;
  display: grid;
  grid-template-columns: 3fr 1fr;
  background: rgba(255, 255, 255, 0.3);
  padding: 15px;
  border-radius: 0 0 10px 45px;
  margin-top: -15px;
  margin-bottom: 15px;
}

#puzzle-list {
  overflow: hidden;
  overflow-y: auto;
  grid-column-start: 2;
  grid-column-end: 3;
  padding-right: 10px;
}

.img-list-item {
  position: relative;
  padding: 5px 5px 0 5px;
}

.img-list-item .preview-container {
  border-radius: 10px 45px 0 0;
}

.img-list-item .preview {
  position: relative;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  height: 150px;
  border-radius: 10px 45px;
  box-shadow: inset 0 0 35px 5px rgba(0, 0, 0, 0.25),
    inset 0 2px 1px 1px rgba(255, 255, 255, 0.5),
    inset 0 -2px 1px 0 rgba(46, 15, 15, 0.25);
  filter: grayscale(100%);
  margin-bottom: 15px;
}

.img-list-item .preview:hover {
  filter: none;
}

#add-src {
  box-shadow: inset 0 0 35px 5px rgba(0, 0, 0, 0.25),
    inset 0 2px 1px 1px rgba(255, 255, 255, 0.5),
    inset 0 -2px 1px 0 rgba(0, 0, 0, 0.25);
  border-radius: 10px 45px;
  height: 150px;
  margin: 5px;
  color: white;
  font-size: 1.4em;
  text-align: center;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: 0px 1px 1px #4d4d4d;
  background-color: green;
}

#add-src:hover {
  background-color: lightgreen;
}

.remove {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

#remove {
  cursor: pointer;
  color: rgba(255, 0, 0, 0.5);
}

#remove:hover {
  color: rgba(255, 0, 0, 1);
}

#temp-image-container {
  margin-top: 15px;
}

#temp-image {
  border-radius: 15px;
  background-size: cover;
}

.img-list-item .preview i {
  color: rgba(255, 255, 255, 0.5);
  position: absolute;
  bottom: 15px;
  right: 15px;
}

.img-list-item .preview i:hover {
  color: rgb(255, 255, 255);
}

#url {
  background: transparent;
  border: none;
  border-bottom: 1px solid #0f74bd;
  padding: 5px;
  width: calc(100% - 10px);
  color: #0f74bd;
}

#url:focus {
  outline: none;
}

.button {
  margin-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/Sidebar.vue